/** The byte store's names (`bytesStore.ts`) at the path its callers import, and logout's
 *  whole-cache clear. */
import { PrimeDebugLog } from "../../util/debugLog";
import { CACHE_ROOT_DIR } from "./protectedCacheReconcile";

export {
    clearFileCacheForTenant,
    loadFileAndCache,
    loadFileSourceAndCache,
    prefetchFileToCache,
} from "./bytesStore";
export type {
    LoadedFileSource,
    LoadFileFailure,
    LoadFileOptions,
    LoadFileOutcome,
} from "./bytesStore";

/** Removes the whole OPFS cache root (logout). */
export async function clearFileCache(): Promise<void> {
    if (!navigator?.storage?.getDirectory) {
        return;
    }

    try {
        await navigator?.storage?.persist?.();
        const root = await navigator.storage.getDirectory();
        await root.removeEntry(CACHE_ROOT_DIR, { recursive: true });
        PrimeDebugLog("clearFileCache", `Removed ${CACHE_ROOT_DIR}`);
    } catch (err: any) {
        if (err.name === "NotFoundError") {
            PrimeDebugLog("clearFileCache", "No cache directory to clear");
        } else {
            PrimeDebugLog("clearFileCache", "Failed to clear cache:", err);
        }
    }
}
